// src/components/typography/Footnote.jsx
import React from "react";
import { Typography } from "@mui/material";

const footnoteSx = {
  fontSize: { xs: "0.70rem", md: "0.85rem" },
  lineHeight: 1.4,
  color: "text.secondary",
  mt: 1,
};

export default function Footnote({ children, sx = {}, ...props }) {
  return (
    <Typography
      variant="caption"
      sx={{ ...footnoteSx, ...sx }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export const footnoteStyle = footnoteSx;
